export default "__VITE_ASSET__D1bgaBXi__"